import AWS from "aws-sdk";

export const AWSConfig = {
  bucketName: "shvesa",
  accessKeyId: "AKIAZQ3DS6BCYVESJAPG",
  secretAccessKey: "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",
  region: "me-central-1",
};

AWS.config.update({ region: "me-central-1" });

export const S3 = new AWS.S3({
  accessKeyId: "AKIAZQ3DS6BCYVESJAPG",
  secretAccessKey: "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",
});
